const TrainerInterviste = (props) => {
  const { interviste } = props;

  function formatDateOnly(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  return (
    <div className="trainer-interviste">
      <div className="trainer-interviste-title">Interviste</div>
      <div className="trainer-data-fields">
        {interviste.length > 0 ? (
          interviste.map((intervista, i) => (
            <div key={i} className="trainer-data">
              <div className="trainer-field-row">
                <div className="trainer-field-label">Data Intervista:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {formatDateOnly(intervista.dataIntervista)}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Parlantina:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.parlantina ? "Si" : "No"}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Timidezza:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.timidezza ? "Si" : "No"}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Dinamicità:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.dinamicità ? "Si" : "No"}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Empatia:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.empatia}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Inglese:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.inglese}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">
                  Adeguato Insegnamento:
                </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.adeguatoInsegnamento}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Automunito:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.automunito ? "Si" : "No"}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Piva:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.piva ? "Si" : "No"}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">
                  Luogo Lavorativo Desiderato:
                </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.luogoLavorativoDesiderato}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Annotazione Interna:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.annotazioneInterna}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Punteggio Intervista:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.punteggioIntervista}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Autore:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {intervista.autore}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">Nessuna interviste.</div>
        )}
      </div>
    </div>
  );
};

export default TrainerInterviste;
